<template>
  <div>
    <div class="content">
      <van-form >
        <van-cell-group inset>
          <div class="upload-front">
            <h2 class="upload-titile input-title-hq red-required">磅单图片</h2>
            <div class="upload-front-box">
              <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="steambd_image" :before-read="beforeRead" :after-read="postupimg" :before-delete="deleteFront"></van-uploader>
            </div>
          </div>
          <van-field v-model="previousLoc" name="上一载地点" label="上一载地点" placeholder="请填写上一载地点" @blur="previousLocInput"/>
          <van-field v-model="nextLoc" name="下一载地点" label="下一载地点" placeholder="请填写下一载地点" @blur="nextLocInput"/>
          <cargo-search @handleCargoSelect="handleCargoSelect" labelTitle="上一载品种" selectType="variety" :isRequired="varietyRequired"/>
          <van-field class="remind" left-icon="warning" label="必须选择上一载品种才能进行下一步预约!" label-width="17rem" label-class="custom-label"  readonly/>
          <cargo-search @handleCargoSelect="handleCargoSelect" labelTitle="下一载品种" selectType="nextVariety"/>
        </van-cell-group>
        <div class="padding-box"></div>

      </van-form>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import steamApi from "@/fetch/steamApi.js";
import Compressor from 'compressorjs';
import CargoSearch from '@/components/SteamComponents/CargoSearch';

export default{

  components:{
    CargoSearch
  },
  data()
  {
    return {
      steambd_image:[],
      steambd_url:[],
      gtPzTitle: "磅单品种",
      pzList: [], //品种信息
      gtPzArray: [],
      gtSelectedData: [],
      previousLoc:"",
      nextLoc:"",
      varietyRequired:true,
    }
  },
  created()
  {
    this.$emit("update-info","previousLoc","");
    this.$emit("update-info","nextLoc","");
    this.$emit("update-info","variety","");
    this.$emit("update-info","nextVariety","");


    this.$emit("update-info",'pzImage',[]);
    this.$emit("update-props",false);

  },

  methods:{
    previousLocInput(){
      this.$emit('update-info', "previousLoc" ,this.previousLoc)
    },
    nextLocInput(){
      this.$emit('update-info', "nextLoc" ,this.nextLoc)
    },
    handleCargoSelect(postData)
    {
      var selectType = postData.selectType;
      var value = postData.value;
      this.$emit("update-info",selectType,value);
      if(selectType == 'variety' && value){
        this.$emit("update-props",true);

      }

    },
    beforeRead(file) {
      let quality = 0.6;
      if (file.size < 4 * 1024 * 1024) {
        quality = 0.9;
      } else if (file.size >= 4 * 1024 * 1024 && file.size < 8 * 1024 * 1024) {
        quality = 0.8;
      } else {
        quality = 0.6;
      }
      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          quality: quality,
          success(result) {
            let newfile = new File([result], file.name, {
              type: file.type
            })
            resolve(newfile)
          },
          error(err) {
            console.log('图片压缩失败---->>>>>', err)
          }
        })

      });
    },
    onOversize() {
      Toast('文件大小不能超过 10Mb');
    },

    postupimg(file)
    {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("uploadid", '');
      formData.append("uploadtype", 'steamUploadBd');

      steamApi.postupimg(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.steambd_image = imageData ? [{
            url: weburl + '/' + imageData
          }] : [];
          that.steambd_url = imageData ? [{
            url:   imageData
          }] : [];//imageData ? imageData : "";
          that.$emit("update-info",'pzImage',that.steambd_url);

        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function() {
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    deleteFront() {
      this.steambd_image = [];
      this.steambd_url = [];
    },
  }
}
</script>
<style lang="scss" scoped>
.content {
    margin: 1rem 0 3.75rem;
    margin-bottom: 10rem;
    padding-bottom: env(safe-area-inset-bottom);
    .upload-front {
        padding-top: 0.625rem;
        background: #fff;
        .upload-titile {
            padding: 0.675rem 1rem;
            color: #646566;
        }
        .upload-front-box {
            margin: 0 1rem;
        }
        .last-bottom {
            padding-bottom: 0.625rem;
            border-bottom: 1px solid #ebedf0;
        }
    }
    .padding-box{
      height: 1rem;
    }
}

.remind {
  width:92%;
  background:#fef4e0;
  margin: 0.8rem auto;
  // margin-bottom: 1rem;
  border-radius: 0.2rem;
  color: #fb9b10;
}

/* 修改 label 文字颜色 */
::v-deep .custom-label {
  color: #fb9b10; /* 黄色 */
}
</style>
